import './BikeElevation.scss'

import { i18n } from 'lib/i18n'
import React, { useCallback, useEffect, useRef } from 'react'
import { CountryAndUnit, formatDistance } from 'utils/formatters'

import BikeElevationInformation, { BikeElevationInfo } from '../BikeElevationInformation'
import { BikeElevationSection, createLineGraph } from './bike-elevation-graph-util'

interface BikeElevationProps {
  elevationSections: BikeElevationSection[]
  distance: number
  elevationInfo?: BikeElevationInfo
  countryAndUnit: CountryAndUnit
}

export default function BikeElevation({
  elevationSections,
  distance,
  elevationInfo,
  countryAndUnit,
}: BikeElevationProps): JSX.Element {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const elevationsLabel =
    elevationInfo?.elevation_down === 0 && elevationInfo.elevation_up === 0
      ? i18n('route.instruction.mostly-flat')
      : i18n('route.instruction.elevation')

  const createGraph = useCallback(() => {
    const canvas = canvasRef.current
    if (canvas !== null) {
      // Get the DPR and size of the canvas
      const dpr = window.devicePixelRatio
      const rect = canvas.getBoundingClientRect()

      // Set the "actual" size of the canvas
      canvas.width = rect.width * dpr
      canvas.height = rect.height * dpr

      createLineGraph(canvas, elevationSections)
    }
  }, [elevationSections])

  useEffect(() => {
    createGraph()
  }, [createGraph])

  useEffect(() => {
    window.addEventListener('resize', createGraph)
    return () => window.removeEventListener('resize', createGraph)
  }, [createGraph])

  return (
    <>
      <div className="Elevation-label-container -hds-margin-t-4">
        <span className="Elevation-label">{elevationsLabel}</span>
        <BikeElevationInformation elevationInfo={elevationInfo} countryAndUnit={countryAndUnit} />
      </div>
      <canvas className="Elevation-canvas" ref={canvasRef}></canvas>
      <div className="Elevation-label-container -hds-margin-t-2">
        <span>{formatDistance(0, countryAndUnit)}</span>
        <span>{formatDistance(distance, countryAndUnit)}</span>
      </div>
    </>
  )
}
